/**
 * F-2 P1 chessboards — message debug dynamique pour l'erreur d'init
 * Stockfish dans AutopsyPage. Le précédent texte hardcodé
 * `crossOriginIsolated=false · headers COOP/COEP manquants en prod`
 * était factuellement faux (curl confirmait les 5 paths COOP/COEP OK en
 * prod), trompeur (oriente le debug vers .htaccess alors que la vraie
 * cause C1 = sous-asset CORP cassé, fix en C.2 = `crossorigin` sur le
 * `<link>` Google Fonts), et inutile pour différencier les causes
 * possibles : sub-asset CORP, SharedArrayBuffer non-supporté, service
 * worker intercepteur, etc.
 *
 * On rapporte maintenant l'état RÉEL côté navigateur, séparé par ` · `
 * pour lisibilité dans `<ErrorMessageWithDebug>`.
 *
 * Cf. docs/CHESSBOARDS_AUDIT.md §F-2 + tests `buildAutopsyDebugString.test.ts`.
 */
export function buildAutopsyDebugString(): string {
  const parts: string[] = [];
  if (typeof window !== 'undefined') {
    parts.push(`crossOriginIsolated=${String(window.crossOriginIsolated ?? 'n/a')}`);
  }
  parts.push(`SharedArrayBuffer=${typeof SharedArrayBuffer !== 'undefined'}`);
  if (typeof navigator !== 'undefined' && navigator.userAgent) {
    parts.push(`UA=${navigator.userAgent.slice(0, 80)}`);
  }
  return parts.join(' · ');
}
